export default "__VITE_ASSET__e916d195__"